module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/FolderDiamond.41c5fed4.svg";